import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import "./VendorResetPassword.css";

// Vendors arrive here from the recovery link in the force-reset email.
// Supabase's redirect includes tokens in the URL that the client SDK
// exchanges for a temporary "recovery" session automatically — by the
// time this component mounts, supabase.auth already has that session,
// we just need to confirm it and let them set a real password.
export default function VendorResetPassword() {
  const [ready, setReady]       = useState(false);
  const [invalid, setInvalid]   = useState(false);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm]   = useState("");
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const { data: listener } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "PASSWORD_RECOVERY") {
        setReady(true);
      }
    });

    // Fallback: if the event already fired before this listener attached,
    // check for an existing session directly.
    supabase.auth.getSession().then(({ data }) => {
      if (data?.session) setReady(true);
      else setTimeout(() => {
        if (!ready) setInvalid(true);
      }, 2500);
    });

    return () => listener?.subscription?.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords don't match.");
      return;
    }

    setSaving(true);
    const { error: updateErr } = await supabase.auth.updateUser({ password });
    setSaving(false);

    if (updateErr) {
      setError(updateErr.message || "Couldn't update your password. Try the link again.");
      return;
    }

    navigate("/vendor/dashboard");
  };

  if (invalid) {
    return (
      <div className="vrp-page">
        <div className="vrp-card">
          <h2>This link has expired</h2>
          <p>Reset links are one-time use. Contact support@bizbazevents.com for a new one.</p>
        </div>
      </div>
    );
  }

  if (!ready) {
    return (
      <div className="vrp-page">
        <div className="vrp-card">
          <p>Verifying your reset link…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="vrp-page">
      <div className="vrp-card">
        <h2>Set your new password</h2>
        <p className="vrp-sub">Choose a password you haven't used before.</p>

        <form onSubmit={handleSubmit}>
          {error && <p className="vrp-error">{error}</p>}

          <label>New password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="At least 8 characters"
            required
          />

          <label>Confirm password</label>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder="Re-enter your password"
            required
          />

          <button type="submit" disabled={saving}>
            {saving ? "Saving…" : "Set password"}
          </button>
        </form>
      </div>
    </div>
  );
}